module.exports = __webpack_public_path__ + "media/images/emblems/GW-TG-Uesslingen-Buch-472be9b56fe719f9995843d763e8d941.png";